import { render, staticRenderFns } from "./Informations.vue?vue&type=template&id=57d0db7e"
import script from "./Informations.vue?vue&type=script&lang=js"
export * from "./Informations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports